import { render, staticRenderFns } from "./RightFirst.vue?vue&type=template&id=95b9c5d6&scoped=true"
import script from "./RightFirst.vue?vue&type=script&lang=js"
export * from "./RightFirst.vue?vue&type=script&lang=js"
import style0 from "./RightFirst.vue?vue&type=style&index=0&id=95b9c5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b9c5d6",
  null
  
)

export default component.exports